(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // GO Organics Predictive Search
  (function() {
    const input = document.getElementById('go-search-input');
    const dropdown = document.getElementById('go-search-dropdown');
    if (!input || !dropdown) return;
    let debounceTimer;
    function formatMoney(cents) { return '₹' + (cents / 100).toFixed(0); }
    function showDropdown(results, query) {
      if (!results.length) {
        dropdown.innerHTML = '<div class="go-search-no-results">No products found for "' + query + '"</div>';
      } else {
        let html = '';
        results.slice(0, 5).forEach(function(item) {
          const img = item.featured_image ? item.featured_image.url + '&width=80' : '';
          const price = item.price_min ? formatMoney(item.price_min) : '';
          html += '<a href="' + item.url + '" class="go-search-result">';
          if (img) html += '<img src="' + img + '" alt="' + item.title + '">';
          html += '<div class="go-search-result-info"><div class="go-search-result-title">' + item.title + '</div>';
          if (price) html += '<div class="go-search-result-price">' + price + '</div>';
          html += '</div></a>';
        });
        html += '<a href="/search?type=product&q=' + encodeURIComponent(query) + '" class="go-search-view-all">View all results →</a>';
        dropdown.innerHTML = html;
      }
      dropdown.classList.add('active');
    }
    input.addEventListener('input', function() {
      const query = this.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) { dropdown.classList.remove('active'); return; }
      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            const items = data.resources && data.resources.results && data.resources.results.products || [];
            showDropdown(items, query);
          })
          .catch(function() { dropdown.classList.remove('active'); });
      }, 250);
    });
    document.addEventListener('click', function(e) {
      if (!input.contains(e.target) && !dropdown.contains(e.target)) dropdown.classList.remove('active');
    });
    input.addEventListener('focus', function() {
      if (this.value.trim().length >= 2) dropdown.classList.add('active');
    });
  })();

  // Update mobile cart badge dynamically
  document.addEventListener('go:cart:updated', function(e) {
    const badge = document.getElementById('go-mobile-cart-count');
    if (badge && e.detail && e.detail.item_count !== undefined) {
      badge.textContent = e.detail.item_count;
      badge.style.display = e.detail.item_count > 0 ? 'flex' : 'none';
    }
  });

  // GO Organics: dynamically size right panel
  function goFixHeaderLayout() {
    const header = document.querySelector('.header--middle-left');
    const logo = document.querySelector('.header__heading-link');
    const rightPanel = document.querySelector('.go-right-panel');
    const mainCol = document.querySelector('.go-right-panel__main');
    const trackPanel = document.querySelector('.go-track-panel');
    if (!header || !logo || !rightPanel || !mainCol || !trackPanel) return;
    const headerWidth = header.getBoundingClientRect().width;
    const logoWidth = logo.getBoundingClientRect().width;
    const trackWidth = trackPanel.getBoundingClientRect().width;
    const available = headerWidth - logoWidth - trackWidth - 32;
    if (available > 300) {
      mainCol.style.minWidth = available + 'px';
      mainCol.style.maxWidth = available + 'px';
      mainCol.style.width = available + 'px';
    }
  }
  document.addEventListener('DOMContentLoaded', goFixHeaderLayout);
  window.addEventListener('resize', goFixHeaderLayout);
  setTimeout(goFixHeaderLayout, 50);

  } catch(e) { console.error(e); }
})();
})();
